  import React, { useContext, useState, useMemo } from 'react';
  import { SearchBoxContext } from '../../contexts/SearchBoxContext';
  import { useLocation } from '../../contexts/useLocation';
  import { ResponsiveContext } from '../../contexts/ResponsiveContext';
  import { isHomeScreen } from '../../utils/screenRouteChecks';
  import { CgSearch } from 'react-icons/cg';
  import { navigate } from 'gatsby';
  import { debounce } from 'lodash';

  type Props = {
    hideResults?: boolean;
    isSearchScreen?: boolean;
    isDrawer?: boolean;
    collapsed?: boolean;
    setCollapsed?: (value: boolean) => void;
  };

  const SearchBox = ({ isSearchScreen = false, isDrawer = false }: Props) => {
    const { pathname } = useLocation();
    const { responsiveState, dispatch } = useContext(ResponsiveContext);
    const { setShowSearchResult, setSearchQuery, searchQuery } = useContext(SearchBoxContext);

    const [controllerState, setControllerState] = useState({ value: searchQuery || '' });

    const debouncedSetSearchQuery = useMemo(() => debounce((val: string) => setSearchQuery(val), 300), [setSearchQuery]);

    const submitSearch = () => {
      if (responsiveState.isMenuActive) {
        dispatch({ type: 'toggleMenu' });
      }
      setSearchQuery(controllerState.value);
      /* debouncedSetSearchQuery.flush?.(); */

      if (!isSearchScreen) {
        navigate('/search');
      } else {
        setShowSearchResult(true);
      }
    };

    return (
      <div className="mb-1 mt-[6px] p-0 border-transparent rounded-2xl inline-block relative">
        <style>
          {`
            input:-webkit-autofill,
            input:-webkit-autofill:hover, 
            input:-webkit-autofill:focus,
            input:-webkit-autofill:active {
              -webkit-box-shadow: 0 0 0 1000px ${
                isDrawer ? '#3C3A42' : (isHomeScreen(pathname) || isSearchScreen)? '#3C3A42' : '#F1F0F4'
              } inset !important;
              -webkit-text-fill-color: ${
                isDrawer ? '#97A3B7' : (isHomeScreen(pathname) || isSearchScreen) ? '#97A3B7' : '#1E1E1E'
              } !important;
              transition: background-color 5000s ease-in-out 0s;
            }

            .dark input:-webkit-autofill,
            .dark input:-webkit-autofill:hover, 
            .dark input:-webkit-autofill:focus,
            .dark input:-webkit-autofill:active {
              -webkit-box-shadow: 0 0 0 1000px ${
                isDrawer ? '#3C3A42' : (isHomeScreen(pathname) || isSearchScreen) ? '#3C3A42' : '#3C3A42'
              } inset !important;
              -webkit-text-fill-color: ${
                isDrawer ? '#97A3B7' : (isHomeScreen(pathname) || isSearchScreen) ? '#97A3B7' : '#97A3B7'
              } !important;
              transition: background-color 5000s ease-in-out 0s;
            }
            `}
        </style>
        <form
          className="flex items-center max-w-xs mx-auto"
          onSubmit={(event) => {
            event.preventDefault();
            submitSearch();
          }}
        >
          <input
            type="text"
            id="simple-search"
            autoComplete="off"
            className={`h-8 border-none outline-none ${
              isDrawer
                ? 'bg-medium-dark-grey! text-soft-blue-grey!'
                : (isHomeScreen(pathname) || isSearchScreen)
                  ? 'bg-medium-dark-grey! text-soft-blue-grey!'
                  : 'bg-very-light-grey! dark:bg-medium-dark-grey!'
            } border border-transparent text-medium-dark-grey! dark:text-soft-blue-grey! text-sm rounded-2xl block w-full pl-3 pr-10 py-2`}
            value={controllerState.value}
            onChange={(e) => {
              const value = e.target.value;
              setControllerState({ value });

              if (isSearchScreen) {
                debouncedSetSearchQuery(value);
              }
            }}
          />
          <div
            className={`${
              isDrawer
                ? 'text-bright-white'
                : (isHomeScreen(pathname) || isSearchScreen)
                  ? 'text-bright-white'
                  : 'dark:text-bright-white text-very-dark-grey'
            } absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none`}
          >
            <CgSearch />
          </div>
        </form>
      </div>
    );
  };

  export default SearchBox;
